const config = {
	api: '',
	appPath: '/summercamp/app',
	loginTimeout: 18000000
};

export default config;